import { connect } from 'react-redux'
import withDidMountRequest from 'app/connectors/withDidMountRequest'

import { getCurrentProTrackProgressDay } from 'store/entities/identity/selectors'
import { getActivitiesHistory } from 'store/entities/identity/actions'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import { getPageRagardingCurrentDay } from 'helpers'

import ActivitiesGraph from './ActivitiesGraph'

const mapStateToProps = state => {
  return {
    isMobile: getUIWindowSizesWidth(state) < 530,
    currentLevelDay: getCurrentProTrackProgressDay(state),
  }
}

const mergeProps = ({ isMobile, currentLevelDay, ...restState }, { dispatch }, ownProps) => ({
  ...restState,
  ...ownProps,
  onRequest: () =>
    dispatch(
      getActivitiesHistory({ page: getPageRagardingCurrentDay(currentLevelDay, isMobile), limit: isMobile ? 10 : 20 })
    ),
})

export default connect(mapStateToProps, null, mergeProps)(withDidMountRequest(ActivitiesGraph))
